import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAEmQIzw2QZ7OfXQn3gm_zacjKSPJGAevo",
  authDomain: "wa4-mp.firebaseapp.com",
  projectId: "wa4-mp",
  storageBucket: "wa4-mp.firebasestorage.app",
  messagingSenderId: "984495273335",
  appId: "1:984495273335:web:4cd7671ba89707590a1d72"
};

const app = initializeApp(firebaseConfig);

// App Check (reCAPTCHA v3) — protegge le Cloud Functions chiamabili da client non
// autenticati (es. il form "Richiedi accesso"). Si attiva solo se è configurata la
// site key: registra la chiave reCAPTCHA v3 nella console Firebase e impostala in
// REACT_APP_APPCHECK_SITE_KEY. In locale puoi usare REACT_APP_APPCHECK_DEBUG_TOKEN.
const appCheckSiteKey = process.env.REACT_APP_APPCHECK_SITE_KEY;
if (appCheckSiteKey) {
  if (process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west1');

// Abilita persistenza offline per Firestore
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    // Più tab aperte, persistenza abilitata solo in una
    console.warn('Firestore persistence failed: multiple tabs open');
  } else if (err.code === 'unimplemented') {
    // Browser non supporta IndexedDB
    console.warn('Firestore persistence not supported');
  }
});

export default app;
